var _rect, _rect2, _path, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAvb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    fill: "#EDCA59",
    fillOpacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2,
    stroke: "#EDCA59",
    strokeOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12",
    stroke: "#D08700"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 7,
    r: 2,
    fill: "#D08700"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 7,
    r: 2,
    fill: "#D08700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvb);
export default __webpack_public_path__ + "static/media/icon-avb.96ef80c0d5d45d5ccf66acdbd52a7965.svg";
export { ForwardRef as ReactComponent };